import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthUserService } from '../services/auth-user/auth-user.service';
import { Permission } from 'src/app/modules/roles/constants/roles.constants';
import { OfflineDomainService } from 'src/app/shared/utils/offline/services/offline-domain.service';

export const redirectGuard: CanActivateFn = () => {
  const authUserService = inject(AuthUserService);
  const offlineDomainService = inject(OfflineDomainService);
  const router = inject(Router);
  const offline = offlineDomainService.vm.activated();

  if (offline) {
    if (authUserService.hasPermission(Permission.ReadOrders)) {
      return router.parseUrl('/dashboard/orders/resume');
    } else {
      return router.parseUrl('/dashboard/profile');
    }
  } else {
    switch (true) {
      case authUserService.hasPermission(Permission.ManageUsers):
        return router.parseUrl('/dashboard/users');
      case authUserService.hasPermission(Permission.ReadOrders):
        return router.parseUrl('/dashboard/orders/resume');
      case authUserService.hasPermission(Permission.ManageMachines):
        return router.parseUrl('/dashboard/machines');
      case authUserService.hasPermission(Permission.ReadIssues):
        return router.parseUrl('/dashboard/issues');
      case authUserService.hasPermission(Permission.ReadAssignments):
        return router.parseUrl('/dashboard/assignments');
      default:
        return router.parseUrl('/dashboard/profile');
    }
  }
};
